module.exports = __webpack_public_path__ + "static/media/8.53f0ad07.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hats/400/8.png
// module id = 741
// module chunks = 0